<template>
  <div id="app">
    <div id="card" class="">
      <div id="chart">
        <apexchart type="radialBar" class="dark:text-gray-200" height="350" :options="chartOptions" :series="[dataRealtime?.[this.sensor] ?? 0]"></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import { useCounterStore } from "@/store/counter";
import { mapActions, mapState } from "pinia";

export default {
  props: [
    'sensor'
  ],
  data() {
    return {
      colorCheck: '#000',
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar',
          
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '70%',
              //background: '#fff', // i want in dark mode change to #1f2937
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24
              }
            },
            track: {
              background: '#fff', // i want in dark mode change to #4d5c70
              strokeWidth: '100%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -1,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888', // i want in dark mode change to #999
                fontSize: '17px'
              },
              value: {
                formatter: function(val) {
                  return parseInt(val);
                },
                color: '#F86624',
                fontSize: '36px',
                show: true,
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        labels: ['Percent'],
      },
    };
  },
  computed: {
    ...mapState(useCounterStore, ['dataRealtime']),
  },
  methods: {
    ...mapActions(useCounterStore, ['getRealtimeSensor'])
  },
  created() {
    this.getRealtimeSensor()
    this.$emit('dataSen', this.dataRealtime?.[this.sensor])
  },
};
</script>
